export default __webpack_public_path__ + "static/media/e4523fc122e652f90e7e98b632080e3d.svg";